//this is going to store Firebase realtime database API code
import { db } from "./firebase";

//##########3 user API

//create an user and store it at users/id path (it's an asynchronous func)
export const doCreateUser = (id, username, email, cart, orders, address, phoneNumber) =>
  db.ref(`users/${id}`).set({
    username,
    email, 
    cart, 
    orders,
    address,
    phoneNumber
  });

//returns all users from firebase realtime db
export const onceGetUsers = () => db.ref("users").once("value");

export const doGetAnUnser = uid => db.ref(`users/${uid}`);

// other APIs could come below

export const doGetShopList = () => {return (db.ref(`groceryShops`))};


export const addItemToCartPerUser = (uid,cartItem, time_stamp, pinCodeSelected, delivery_addr, delivery_ph) =>
  db.ref(`users/${uid}/cart/${time_stamp}`).set({
    items:cartItem,
    status:"pending",
    pinCode: pinCodeSelected,
    delivery_address: delivery_addr, 
    delivery_phone: delivery_ph,
  // db.ref(`users/${uid}/cart/${time_stamp}`).set({
  //   cartItem,
    
  // })
})
